import 'slick-slider/slick/slick.min';
import './slick.js';

;( function($) {
  // ready
  $(document).ready(function() {

    // Hide menu nav
    let lastScrollTop;
    const navbar = document.getElementById('eprogramme-main-nav');

    // Show/Hide menu on Scroll
    window.addEventListener('scroll', function() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 80 && scrollTop > lastScrollTop) {
        navbar.style.top = '-' + navbar.offsetHeight + 'px';
      }
      else {
        navbar.style.top = '0';
      }
      lastScrollTop = scrollTop;
    });

    // Function for hash links animation
    $(document).on('click', 'a[href^="#"]', function(event) { // Todo: This does not work in production? Resolve!
      // $('.eprogramme-navbar--menu_item').on('click', function(event) {
      event.preventDefault();

      // Close the menu
      $('#eprogramme-navbar--menuToggle_input').prop('checked', false);
      // Remove scroll lock on body
      $('html, body').removeClass('noScroll');
      // Remove the scroll-snap, since it causes jerking
      $('#eprogramme--scroll-container').css({'scroll-snap-type': 'none'});

      //console.log('offTop -- ', $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top);

      // Set target to scroll to
      let scrollTarget = $('[name="' + $.attr(this, 'href').substr(1) + '"]');

      // If no name attr, use id
      if (scrollTarget.length === 0) {
        scrollTarget = $($.attr(this, 'href'));
      }

      /// Animate to target
      $('html, body').delay(300).animate({
        // $('#eprogramme--scroll-container').delay(300).animate({
        scrollTop: scrollTarget.offset().top,
      }, 500, function() {
        // Switch back to scroll snap after animation
        $('#eprogramme--scroll-container').css({'scroll-snap-type': 'y mandatory'});
      });
    });

    // Menu button
    $('#eprogramme-navbar--menuToggle_input').on('click', function(e) {
      if ($(this).prop('checked')) {
        $('html, body').addClass('noScroll');
      }
      else {
        $('html, body').removeClass('noScroll');
      }
    });
  });

} )(jQuery);